import { api } from "../../http";

async function PutDataLayout(data,id) {
  try {
    
    const layout = await api.put(`/layout/${id}`,data);
    return layout;

  } catch (e) {
    console.log(e.message);
  }
}

export { PutDataLayout };
